import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from './../index';
import { Button, Modal, Row, Col, Radio, Form, Input, Checkbox, Select, message } from 'antd';
import Iquanhe from './../../../../src/assets/pvi-benhhiemngheo/iquanhe.svg';
import Ihoten from './../../../../src/assets/pvi-benhhiemngheo/ihoten.svg';
import Ithoigian from './../../../../src/assets/pvi-benhhiemngheo/ithoigian.svg';
import Icmnd from './../../../../src/assets/pvi-benhhiemngheo/icmnd.svg';
import Service from "./../../../extra/getAPI";
import DatePicker from "../modalnotification/DatePicker";
import Helper from "./../../../extra/helper";
import MdRene from "./modalConfirmRenewals";



import moment from "moment";
const ModalAddPeson = (props) => {
  const { listIsu, goStep, step, setListIsu, test, ActionList, dataRenewals, CheckRenewals, getAge } = useContext(AuthContext);
  const { Option } = Select;
  const [form] = Form.useForm();
  const formRef = React.createRef();
  const [listPackageInsuAPI, setListPackageInsuAPI] = useState([]);
  const [formData, setFormData] = useState({});
  const [datePicker, setDatePicker] = useState({});
  const [fee, setFee] = useState(0);
  const [age, setAge] = useState(null);
  const [listInsured, setListInsured] = useState([]);
  const [isModalVisibleRene, setIsModalVisibleRene] = useState(false);
  const [dataStep, setDataStep] = useState({});
  const [fees, setFees] = useState(0);

  useEffect(() => {
    let listInsured2 = JSON.parse(localStorage.getItem('listInsured'));
    let index = props.index;
    let action = props.action;
    if ((index || index === 0) && action === 'edit') {
      form.setFieldsValue(listInsured2[+index]);
      setFormData(listInsured2[+index]);
      // CheckRenewals(listInsured2[+index]?.insuredDob, listInsured2[+index]?.insuredPrivateId);
    } else {
      form.resetFields();
    }
    if (listInsured2) {
      setListInsured(listInsured2);
    }
  }, []);

  useEffect(() => {
    let action = props.action;
    let listInsured2 = JSON.parse(localStorage.getItem('listInsured'));
    let index = props.index;
    let dataIsu = JSON.parse(localStorage.getItem('dataIsu'));
    // if (+age && +age < 16) {
    //   form.setFieldsValue({ "insuredPrivateId": dataIsu?.insuredPrivateId });
    // } else {
    //   if (listInsured2) {
    //     form.setFieldsValue({ "insuredPrivateId": listInsured2[index]?.insuredPrivateId });
    //   }
    // }
    if (listPackageInsuAPI) {
      setFee(listPackageInsuAPI[dataIsu.package - 1]?.value);
    }
  }, [age, listPackageInsuAPI]);

  const actionForm = (val) => {
    form
      .validateFields()
      .then(async (values) => {
        // console.log(values);
        Action(values);
      })
      .catch((err) => {
        console.error('err:', err);
      });
  };

  const Action = (values) => {
    let item = {
      ...values,
      listPackageInsu: listPackageInsuAPI
    }
    setDataStep(item);
    if (props.action === 'add') {
      ActionList('add', '', item);
      props.handleCancel();
      form.resetFields();
      // if (dataRenewals.statusCode === 200 && dataRenewals?.result?.renewals === 0) {
      //   ActionList('add', '', item);
      //   props.handleCancel();
      //   form.resetFields();
      //   // Nếu tuổi hợp lệ và  đơn tái tục thì hiện thông báo xác nhận
      // } else if (dataRenewals.statusCode === 200 && dataRenewals?.result?.renewals === 1) {
      //   setIsModalVisibleRene(true);
      // } else {
      //   message.warning({
      //     content: 'Tuổi của bạn không phù hợp nếu là người được bảo hiểm!',
      //     style: {
      //       marginTop: '10vh',
      //     },
      //   }, 10);
      // }
    } else {
      ActionList('edit', props.index, item);
      form.resetFields();
      props.handleCancel();
      // if (dataRenewals.statusCode === 200 && dataRenewals?.result?.renewals === 0) {
      //   ActionList('edit', props.index, item);
      //   form.resetFields();
      //   props.handleCancel();
      //   // Nếu tuổi hợp lệ và  đơn tái tục thì hiện thông báo xác nhận
      // } else if (dataRenewals.statusCode === 200 && dataRenewals?.result?.renewals === 1) {
      //   setIsModalVisibleRene(true);
      // } else {
      //   message.warning({
      //     content: 'Tuổi của bạn không phù hợp nếu là người được bảo hiểm!',
      //     style: {
      //       marginTop: '10vh',
      //     },
      //   }, 10);
      // }
    }
  }

  const handleCancelRene = () => {
    setIsModalVisibleRene(false);
  };

  const ConfirmRene = (key) => {
    setIsModalVisibleRene(!isModalVisibleRene);
    if (key === 'yes') {
      if (props.action === 'add') {
        ActionList('add', '', dataStep);
      } else {
        ActionList('edit', props.index, dataStep);
      }
    }
    props.handleCancel();
    form.resetFields();
  }

  useEffect(() => {
    if (formData.insuredDob && formData.insuredGender) {
      // getPackageInsu();
      getFees();
      setFormData({
        ...formData,
      });
    }
  }, [formData.insuredDob, formData.insuredGender]);

  const getFees = async () => {
    let dataIsu = JSON.parse(localStorage.getItem('dataIsu'));
    const param = {
      yearsOfInsurance: dataIsu.yearsOfInsurance,
      packageId: dataIsu.package,
      listOfInsuredPeople: [
        {
          insuredDob: moment(formData?.insuredDob, "DD/MM/YYYY").format("YYYY-MM-DD"),
          insuredGender: +formData?.insuredGender
        }
      ]
    };
    const res = await Service.apicall(
      "POST",
      `/v1/products/critical-disease/fees`,
      param
    );
    setFees(res?.data?.data?.fees);
    // if(getAge(formData?.insuredDob) < 16){
    //   form.setFieldsValue({ "insuredPrivateId": dataIsu?.insuredPrivateId });
    // }
    setAge(getAge(formData?.insuredDob));
  };

  // const getPackageInsu = async () => {
  //   const dataApi = [
  //     {
  //       "id": 1,
  //       "title": "Gói bảo hiểm 1",
  //       "price": 190000000,
  //       "value": 119000
  //     },
  //     {
  //       "id": 2,
  //       "title": "Gói bảo hiểm 2",
  //       "price": 380000000,
  //       "value": 238000
  //     },
  //     {
  //       "id": 3,
  //       "title": "Gói bảo hiểm 3",
  //       "price": 760000000,
  //       "value": 475000
  //     },
  //     {
  //       "id": 4,
  //       "title": "Gói bảo hiểm 4",
  //       "price": 1520000000,
  //       "value": 950000
  //     }
  //   ];
  //   if (dataApi?.length > 0) {
  //     setListPackageInsuAPI(dataApi);
  //     // setAge(19); củ
  //     setAge(getAge(formData?.insuredDob));
  //     // console.log(formData?.insuredDob);
  //   }
  // };

  const onChangForm = ({ data, name }) => {
    setFormData({
      ...formData,
      [name]: data,
    });
  };

  const css = {
    input: { color: '#3A3A3A', zIndex: 1, fontSize: 15, boxShadow: 'none', padding: '10px 35px', borderRadius: 9, width: '100%' },
    titleInput: { color: '#646D69', marginBottom: 3 },
    FormItemsHolder: { width: "100%", borderRadius: 8, margin: '5px 0px', padding: 0 },
    iconInput: { width: 20, margin: '14px 10px', position: 'absolute', zIndex: 2 }
  }

  return (
    <div style={{ fontSize: 14 }}>
      {
        isModalVisibleRene &&
        <MdRene ConfirmRene={ConfirmRene} handleCancel={handleCancelRene} isModalVisible={isModalVisibleRene} />
      }
      {datePicker.open && (
        <DatePicker
          onConfirm={(data) => {
            onChangForm({ data, name: "insuredDob" });
            form.setFieldsValue({ "insuredDob": data });
            // CheckRenewals(data, formData.insuredPrivateId);
          }}
          // max={moment().subtract(16, "y").toDate()}
          // // min={moment().add(1, "d").subtract(JSON.parse(localStorage.getItem('dataIsu'))?.yearsOfInsurance === 1 ? 65 : 55, "y").toDate()}
          // min={moment().add(1, "d").subtract(55, "y").toDate()}
          max={moment().add(1, 'd').subtract(15, "y").toDate()}
          min={moment().add(2, 'd').subtract(55, "y").toDate()}
          visible={datePicker.open}
          close={() => {
            setDatePicker({ ...datePicker, open: false });
          }}
          value={formData.insuredDob}
        />
      )}
      <Modal
        className="custom-modal-antd"
        style={{ maxWidth: '100%', margin: 0, verticalAlign: 'bottom', padding: 0, maxHeight: '90%' }}
        centered={true}
        footer={false}
        closable={true}
        open={props.isModalVisible}
        onCancel={props.handleCancel}
        maskStyle={{ background: '#000000', opacity: 0.8 }}
      >
        <Form
          ref={formRef}
          form={form}
          onFinish={actionForm}
          name="VAT"
        >
          <div>
            <div style={{ borderBottom: '2px solid #828EE1', padding: '0px 10px 10px 10px', fontWeight: 500, fontSize: 16, marginTop: -10 }}>Thông tin người thân</div>
            <div style={{ padding: '10px 10px 0px 10px', position: 'relative' }}>
              <div style={css.titleInput}>Họ và tên<span style={{ color: 'red' }}>*</span></div>
              <img style={css.iconInput} src={Ihoten} alt="quyen loi" />
              <Form.Item
                name="insuredName"
                rules={[{
                  required: true,
                  message: 'Vui lòng chọn và nhập thông tin',
                },
                {
                  min: 5,
                  message: 'Họ tên tối thiểu phải 5 ký tự',
                }
                ]}
                style={css.FormItemsHolder}
              >
                <Input autoComplete="off"
                  style={{ ...css.input, textTransform: 'capitalize' }}
                  placeholder='Nhập họ và tên'
                />
              </Form.Item>
            </div>
            <div style={{ padding: '10px 10px 0px 10px', position: 'relative' }}>
              <div style={css.titleInput}>Quan hệ với người mua bảo hiểm<span style={{ color: 'red' }}>*</span></div>
              <img style={css.iconInput} src={Iquanhe} alt="quyen loi" />
              <Form.Item
                name="relationshipWithBuyerId"
                rules={[{
                  required: true,
                  message: 'Vui lòng chọn và nhập thông tin',
                }]}
                style={css.FormItemsHolder}
              >
                <Select
                  className="custom-select-antd-padding"
                  // showSearch
                  autoComplete="off"
                  // allowClear={true}
                  placeholder="Chọn mối quan hệ"
                >
                  <Option value={2}>Vợ/chồng</Option>
                  <Option value={4}>Bố/Mẹ</Option>
                  <Option value={3}>Con</Option>
                  <Option value={5}>Anh/chị/em ruột</Option>
                </Select>
              </Form.Item>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 10px 0px 10px' }}>
              <div style={{ width: '50%', marginRight: 5 }}>
                <div style={{ padding: '0px', position: 'relative' }}>
                  <div style={css.titleInput}>Ngày sinh<span style={{ color: 'red' }}>*</span></div>
                  <img style={css.iconInput} src={Ithoigian} alt="quyen loi" />
                  <Form.Item
                    name="insuredDob"
                    rules={[{
                      required: true,
                      message: 'Vui lòng chọn và nhập thông tin',
                    }]}
                    style={css.FormItemsHolder}
                  >
                    <Input autoComplete="off"
                      style={css.input}
                      readOnly
                      placeholder='DD/MM/YYYY'
                      onClick={() => {
                        setDatePicker({ ...datePicker, open: true });
                      }}
                    />
                  </Form.Item>
                </div>
              </div>
              <div style={{ width: '50%', marginLeft: 5 }}>
                <div style={{ padding: '0px', position: 'relative' }}>
                  <div style={css.titleInput}>Giới tính<span style={{ color: 'red' }}>*</span></div>
                  <img style={css.iconInput} src={Ihoten} alt="quyen loi" />
                  <Form.Item
                    name="insuredGender"
                    rules={[{
                      required: true,
                      message: 'Vui lòng chọn và nhập thông tin',
                    }]}
                    style={css.FormItemsHolder}
                  >
                    <Select
                      className="custom-select-antd-padding"
                      autoComplete="off"
                      placeholder="Chọn giới tính"
                      onChange={(e) => {
                        onChangForm({ data: e, name: "insuredGender" });
                      }}
                    >
                      <Option value="1">Nam</Option>
                      <Option value="2">Nữ</Option>
                    </Select>
                  </Form.Item>
                </div>
              </div>
            </div>
            <div style={{ padding: '10px 10px 0px 10px', position: 'relative' }}>
              <div style={css.titleInput}>CMND/ CCCD/ Hộ chiếu<span style={{ color: 'red' }}>*</span></div>
              <img style={css.iconInput} src={Icmnd} alt="cmnd" />
              <Form.Item
                name="insuredPrivateId"
                rules={[{
                  required: true,
                  message: 'Vui lòng nhập CMND/CCCD 9 số hoặc 12 số, không bao gồm ký tự đặc biệt.',
                  pattern: /^[A-Z][0-9]{7}$|^[0-9]{9}$|^[0-9]{12}$/
                }]}
                style={css.FormItemsHolder}
              >
                <Input autoComplete="off"
                  onChange={(e) => {
                    onChangForm({ data: e.target.value, name: "insuredPrivateId" });
                    // CheckRenewals(formData.insuredDob, e.target.value);
                  }}
                  style={css.input}
                  placeholder='Nhập CMND, CCCD hoặc Hộ chiếu'
                />
              </Form.Item>
            </div>
            {/* <div style={{ padding: '0px 10px 10px 10px', color: '#646D69' }}>
              <i>Trẻ em dưới 16 tuổi thì nhập CMND/CCCD của người mua</i>
            </div> */}
            <div style={{ padding: '10px 10px 20px 10px', display: 'flex', justifyContent: 'space-between' }}>
              <span style={{ fontWeight: 700 }}>Mức phí bảo hiểm</span>
              <span style={{ fontWeight: 700 }}>{fees} VNĐ</span>
            </div>
            <div style={{ borderRadius: '16px 16px 0px 0px', justifyContent: 'center', padding: '16px 18px 20px 18px', boxShadow: '0px -4px 8px rgba(0, 0, 0, 0.1)', width: '100%', background: '#ffffff', }}>
              <Button onClick={() => actionForm()} size="large" style={{ fontSize: 14, background: '#2A3790', color: '#ffffff', width: '100%', textAlign: 'center', borderRadius: 8, fontWeight: 700, height: 45 }}>
                {props.action === 'add' ? 'Thêm' : 'Cập nhật'}
              </Button>
            </div>
          </div>
        </Form>
      </Modal>
    </div >
  );
};

export default ModalAddPeson;
